import React, { Fragment, useState, useEffect, useRef, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';
import { Grid, Typography, FormControl, makeStyles } from '@material-ui/core';
import { TextField, Select, TextFieldDatePicker, HelperText } from '@components/atoms';
import { DragNDrop, DialogAlert } from '@components/molecules';
import { CredentialsService } from '@services';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    imageWrapper: {
        marginTop: theme.spacing(3),
    },
    typography: {
        color: theme.palette.primary.main,
    }
}));

const CertificateFields = (props) => {
    const {
        filterValues, isSmUp, hash, formik, formik: { values }, state, setState, setOpenModal,
        addCertificate, eCardData, setECardData, setIsFrontImageRequired, setIsBackImageRequired,
        isChangingImage, setIsChangingImage, certificates, certificateTypes, eCardDataUpdatedRef
    } = props;
    const [eCardMapData, setEcardMapData] = useState();
    const [isEcard, setIsEcard] = useState(false);
    const [ecardAlert, setEcardAlert] = useState(false);
    const classes = useStyles();
    const previousCertificateRef = useRef();

    const handleEcardModal = () => {
        setOpenModal(true);
        setEcardAlert(false);
    }

    const handleChangeImage = () => {
        formik.setFieldValue('certificateImage', '');
        // setIsChangingImage(true);
    }

    useEffect(() => {
        if (addCertificate) setIsChangingImage(true);
        if (!values.certificateID || !Object.values(values).join('').length) {
            previousCertificateRef.current = '';
            return;
        }
        if (previousCertificateRef.current && previousCertificateRef.current !== values.certificateID) {
            if (Number(values.certificateID) !== 268)
                setState(prevState => ({ ...prevState, stateDLFormat: null }));
            ['documentNumber', 'agency', 'stateCode', 'countyName', 'issueDate', 'expirationDate', 'frontImage', 'backImage'].forEach(v => {
                formik.setFieldValue(v, '', false);
                formik.setFieldTouched(v, false);
            });
            !eCardDataUpdatedRef.current && setECardData();
            if (addCertificate && !eCardData && values.certificateID && [142, 409, 166, 230, 233, 143, 231, 410, 167].includes(Number(values.certificateID))) setEcardAlert(true);
        }
        if (!previousCertificateRef.current) {
            if (addCertificate && !eCardData && values.certificateID && [142, 409, 166, 230, 233, 143, 231, 410, 167].includes(Number(values.certificateID))) setEcardAlert(true);
        }
        previousCertificateRef.current = values.certificateID;
        const selectedCertificate = certificateTypes.find(v => Number(values.certificateID) === Number(v.certificateID));
        setIsFrontImageRequired(selectedCertificate.isFrontImageRequired === "True" ? true : false);
        setIsBackImageRequired(selectedCertificate.isBackImageRequired === "True" ? true : false);
        let isEcardCert = false;
        if (!eCardMapData) {
            CredentialsService.eCardMapping()
                .then(eCards => {
                    isEcardCert = !!eCards.find(eCard => Number(selectedCertificate.certificateID) === Number(eCard.codeValue));
                    setIsEcard(isEcardCert);
                    setEcardMapData(eCards);
                    setEcardAlert(isEcardCert);
                });
        } else {
            isEcardCert = !!eCardMapData.find(eCard => Number(selectedCertificate.certificateID) === Number(eCard.codeValue));
            setIsEcard(isEcardCert);
        }
        let statesOptions = [], countiesOptions = [];
        // const certTypesBasedonAddCertFlag = addCertificate ? filterValues.certificateTypes : certificateTypes;
        let filterCertBasisOfAddUpdateFlag;
        if (certificates) {
            filterCertBasisOfAddUpdateFlag = (addCertificate ? certificates : certificates.filter(cert => cert.certificateID !== selectedCertificate.certificateID)).filter(cert => !['MISSING', 'REJECTED'].includes(cert?.disposition));
        }
        const addedStateOrCountyCerts = filterCertBasisOfAddUpdateFlag ? filterCertBasisOfAddUpdateFlag.filter(addedCert => Number(addedCert.certificateID) === Number(values.certificateID)) : [];
        if ([1, 2].includes(Number(selectedCertificate.stateCounty))) {
            /* const addedStateCerts = certTypesBasedonAddCertFlag.reduce((acc, certType) => {
                const cert = filterCertBasisOfAddUpdateFlag.filter(addedCert => addedCert.certificateID === certType.certificateID && ["1", "2"].includes(certType.stateCounty))
                if (cert?.length)
                    acc.push(...cert);
                return acc;
            }, []); */

            const stateCodes = addedStateOrCountyCerts.filter(cert => !!cert.stateCode && (addCertificate ? true : cert.stateCode !== values.stateCode)).map(v => v.stateCode);
            const filteredStates = filterValues.stateCountyOptions.filter(item => !stateCodes.includes(item.stateCode));
            statesOptions = ([1].includes(Number(selectedCertificate.stateCounty)) ? filteredStates : filterValues.stateCountyOptions).map(v => ({ label: v.stateDescription, value: v.stateCode }));
            // console.log('selectedCertificate.stateCounty', [1].includes(Number(selectedCertificate.stateCounty)) ? 'State cert' : 'county cert', 'statesOptions', statesOptions);
        }
        if (values.stateCode && [2].includes(Number(selectedCertificate.stateCounty))) {
            /* const addedCountyCerts = certTypesBasedonAddCertFlag.reduce((acc, certType) => {
                const cert = filterCertBasisOfAddUpdateFlag.filter(addedCert => addedCert.certificateID === certType.certificateID && ["2"].includes(certType.stateCounty) && !!addedCert.stateCode);
                if (cert?.length)
                    acc.push(...cert);
                return acc;
            }, []); */
            const tempStateCountyOptions = Array.from(filterValues.stateCountyOptions);
            const groupByStates = _.groupBy(addedStateOrCountyCerts, 'stateCode');

            // const tempRemovedAddedStateCounties = tempStateCountyOptions.filter(v => !_.keys(groupByStates).includes(v.stateCode));
            // let modifiedStateCounties = [];
            let tempModifiedStateCounties = [...tempStateCountyOptions];
            _.keys(groupByStates).forEach(item => {
                let stateInfo = tempStateCountyOptions.find(v => v.stateCode == item);
                if (stateInfo?.counties?.length) {
                    const tempCounties = Array.from(stateInfo.counties);
                    const addedCounties = groupByStates[item].filter(v => !!v.countyName).map(v => v.countyName);
                    const filteredCounties = tempCounties.filter(v => !addedCounties.includes(v));
                    /*  modifiedStateCounties = [...modifiedStateCounties, ...tempStateCountyOptions.reduce((acc, v) => {
                         if (v.stateCode == item) {
                             const data = { ...v };
                             data.counties = [...filteredCounties];
                             acc.push(data);
                         }
                         return acc;
                     }, [])]; */
                    tempModifiedStateCounties = tempModifiedStateCounties.map(v => {
                        if (v.stateCode == item) {
                            const data = { ...v };
                            data.counties = [...filteredCounties];
                            return data;
                        }
                        return v;
                    });
                }
            });
            // const filteredStateCountyOptions = _.sortBy([...tempRemovedAddedStateCounties, ...modifiedStateCounties], 'stateCode');
            countiesOptions = tempModifiedStateCounties.find(v => v.stateCode == values.stateCode).counties.map(v => ({ label: v, value: v }));
        }
        //const statesOptions = ["1", "2"].includes(selectedCertificate.stateCounty) ? filterValues.stateCountyOptions.map(v => ({ label: v.stateDescription, value: v.stateCode })) : [];
        //const countiesOptions = values.stateCode && ["2"].includes(selectedCertificate.stateCounty) ? filterValues.stateCountyOptions.find(v => v.stateCode == values.stateCode).counties.map(v => ({ label: v, value: v })) : [];
        setState(prevState => ({ ...prevState, selectedCertificate, statesOptions, countiesOptions }));
    }, [values, addCertificate]);

    const isMissingCert = useMemo(() => (formik.values.certificateID && certificates ? certificates.find(cert => Number(cert.certificateID) === Number(formik.values.certificateID))?.disposition === 'MISSING' : false), [state.selectedCertificate]);

    const checkSelectedCertType = useCallback(() => {
        if (!isEcard) {
            setECardData();
        }
    }, [isEcard]);

    useEffect(() => {
        checkSelectedCertType();
    }, [isEcard]);

    const onStateChange = async (event) => {
        formik.handleChange(event);
        formik.setFieldValue('documentNumber', '');
        formik.setFieldTouched('documentNumber', false);
        if (Number(values.certificateID) === 268) { //driversLicense
            const response = await CredentialsService.getStateDLFormat(event.target.value);
            setState(prevState => ({ ...prevState, stateDLFormat: response[0] }));
        }
    }

    const onDateChange = e => {
        let result = e.target.value;
        if (Number(result?.split('-')[0]) > 2099) result = '2099' + result.substring(4);
        else if (Number(result?.split('-')[0]) < 2000) result = '2000' + result.substring(4);
        const args = e;
        args.target.value = result;
        formik.handleChange(args);
        formik.handleBlur(args);
    }

    const onIssueDateChange = e => {
        if (state.selectedCertificate.certificateID === '242') {
            const setExpDate = moment(e.target.value).add(1, 'year').format('YYYY-MM-DD')
            formik.setFieldValue('expirationDate', setExpDate);
        }
        formik.setFieldValue('issueDate', e.target.value);
    }

    const renderState = (
        <Select
            {...{
                name: 'stateCode',
                label: formik.values.stateCode === 'CD' ? '' : 'State',
                className: 'center',
                onChange: onStateChange,
                onBlur: formik.handleBlur,
                options: formik.values.stateCode === 'CD' ? [{value: 'CD', label: 'CANADA'}] : state.statesOptions ? state.statesOptions : [],
                formProps: { variant: "outlined", required: true, fullWidth: true, },
                value: formik.values.stateCode,
                error: formik.touched.stateCode && Boolean(formik.errors.stateCode),
                helperText: formik.touched.stateCode && formik.errors.stateCode,
                disabled: formik.values.stateCode === 'CD' ? true : false
            }} />
    );

    const renderStateCountyBasedOnCertificate = () => {
        if ((state.selectedCertificate && !parseInt(state.selectedCertificate.stateCounty)) || !state.selectedCertificate) return null;
        if (state.selectedCertificate.certificateName === "Drivers License-Canada" && formik.values.stateCode !== "CD") (
            formik.setFieldValue('stateCode', 'CD')
        )
        return (
            state.selectedCertificate.stateCounty == "1" ? renderState : (
                <Fragment>
                    {renderState}
                    <Select
                        {...{
                            name: 'countyName',
                            label: 'County',
                            className: 'center',
                            onChange: formik.handleChange,
                            onBlur: formik.handleBlur,
                            options: state.countiesOptions || [],
                            formProps: { variant: "outlined", required: true, fullWidth: true, },
                            value: formik.values.countyName,
                            disabled: !values.stateCode,
                            error: formik.touched.countyName && Boolean(formik.errors.countyName),
                            helperText: formik.touched.countyName && formik.errors.countyName,
                        }} />
                </Fragment>
            )
        );
    }

    const renderCertificateFields = () => {
        if (formik.values.stateCode === 'NJ' && formik.values.documentNumber.includes(':')) {
            const splitCertNumberAndZipCode = formik.values.documentNumber.split(':');
            formik.setFieldValue('documentNumber', splitCertNumberAndZipCode[0]);
            formik.setFieldValue('zipCode', splitCertNumberAndZipCode[1]);
        }

        return (
            <Fragment>
                <Select
                    {...{
                        name: 'certificateID',
                        label: 'Credential Name',
                        className: 'center',
                        // onChange: formik.handleChange,
                        onChange: event => { formik.setFieldValue('certificateID', event.target.value); eCardDataUpdatedRef.current = false; },
                        onBlur: formik.handleBlur,
                        options: state.certificateTypesOptions || [],
                        formProps: { variant: "outlined", required: true, fullWidth: true, },
                        value: formik.values.certificateID,
                        error: formik.touched.certificateID && Boolean(formik.errors.certificateID),
                        helperText: formik.touched.certificateID && formik.errors.certificateID,
                        disabled: !addCertificate && !isMissingCert
                    }} />
                {renderStateCountyBasedOnCertificate()}
                <TextField
                    {...{
                        name: 'documentNumber',
                        label: 'Credential Number',
                        className: 'center',
                        isCapital: true,
                        placeholder: state.stateDLFormat?.formatMsg || '',
                        onChange: event => formik.setFieldValue('documentNumber', _.toUpper(event.target.value)),
                        onBlur: formik.handleBlur,
                        fullWidth: true,
                        required: true,
                        value: formik.values.documentNumber,
                        error: formik.touched.documentNumber && Boolean(formik.errors.documentNumber),
                        helperText: formik.touched.documentNumber && formik.errors.documentNumber,
                        disabled: Number(formik.values.certificateID) === 268 && !formik.values.stateCode,
                    }} />
                    {formik.values.stateCode === 'NJ' && (
                        <TextField
                        {...{
                            name: 'zipCode',
                            label: 'ZIP Code',
                            className: 'center',
                            type: 'number',
                            isCapital: true,
                            onChange: event => formik.setFieldValue('zipCode', event.target.value),
                            onBlur: formik.handleBlur,
                            fullWidth: true,
                            required: true,
                            value: formik.values.zipCode,
                            error: formik.touched.zipCode && Boolean(formik.errors.zipCode),
                            helperText: formik.touched.zipCode && formik.errors.zipCode,
                        }} />
                    )}
                <Select
                    {...{
                        name: 'agency',
                        label: 'Agency',
                        className: 'center',
                        onChange: formik.handleChange,
                        onBlur: formik.handleBlur,
                        options: state.agencyOptions || [],
                        formProps: { variant: "outlined", fullWidth: true, },
                        value: formik.values.agency,
                        error: formik.touched.agency && Boolean(formik.errors.agency),
                        helperText: formik.touched.agency && formik.errors.agency,
                    }} />
                <Grid container justifyContent={"space-between"} >
                    <Grid item md={12}>
                        <TextFieldDatePicker
                            {...{
                                name: 'issueDate',
                                label: 'Issue Date',
                                className: 'center',
                                required: true,
                                onChange: e => onIssueDateChange(e),
                                onBlur: onDateChange,
                                fullWidth: true,
                                variant: "outlined",
                                style: { width: '15rem' },
                                value: formik.values.issueDate,
                                error: formik.touched.issueDate && Boolean(formik.errors.issueDate),
                                helperText: formik.touched.issueDate && formik.errors.issueDate,
                            }} />
                    </Grid>
                    <Grid item md={12}>
                        <TextFieldDatePicker
                            {...{
                                name: 'expirationDate',
                                label: 'Expiration Date',
                                className: 'center',
                                required: true,
                                onChange: formik.handleChange,
                                onBlur: onDateChange,
                                fullWidth: true,
                                variant: "outlined",
                                style: { width: '15rem' },
                                value: formik.values.expirationDate,
                                error: formik.touched.expirationDate && Boolean(formik.errors.expirationDate),
                                helperText: formik.touched.expirationDate && formik.errors.expirationDate,
                                disabled: (!isMissingCert && state?.selectedCertificate?.isExpCert === "False") || state?.selectedCertificate?.certificateID === '242'
                            }} />
                    </Grid>
                </Grid>
            </Fragment>
        );
    }

    const renderImageUploadFields = () => {
        const isEcardCert = [142, 409, 166, 230, 233, 143, 231, 410, 167].includes(Number(formik.values?.certificateID));
        return (
            <Fragment>
                {
                    !addCertificate && values.certificateImage && !isChangingImage && (
                        <Grid item className={classes.imageWrapper}>
                            <FormControl className={classes.formControl} error={formik.touched.certificateImage && Boolean(formik.errors.certificateImage)}>
                                <Typography variant="h6" gutterBottom className={classes.typography}>
                                    Credential Image Upload
                                </Typography>
                                <DragNDrop {...{
                                    name: 'certificateImage',
                                    uploadedImage: formik.values.certificateImage,
                                    hasUploadedImage: !!formik.values.certificateImage,
                                    type: 'png, jpeg, jpg',
                                    changeImageClick: !eCardDataUpdatedRef.current ? () => handleChangeImage() : () => { },
                                    restrictFileExplorer: isEcardCert ? eCardDataUpdatedRef.current || true : false,
                                    dropZoneProps: { disabled: isEcardCert ? eCardDataUpdatedRef.current : false },
                                    disableUpdateImage: isEcardCert ? eCardDataUpdatedRef.current : false,
                                }} />
                                <HelperText {...{
                                    error: formik.touched.certificateImage && Boolean(formik.errors.certificateImage),
                                    helperText: formik.errors.certificateImage,
                                }} />
                            </FormControl>
                        </Grid>
                    )
                }
                {
                    state.selectedCertificate && !values.certificateImage && state.selectedCertificate.isFrontImageRequired === "True" && (
                        <Grid item className={classes.imageWrapper}>
                            <FormControl className={classes.formControl} error={formik.touched.frontImage && Boolean(formik.errors.frontImage)}>
                                <Typography variant="h6" gutterBottom className={classes.typography}>
                                    Front Image Upload
                                </Typography>
                                <DragNDrop {...{
                                    name: 'frontImage',
                                    required: true,
                                    uploadedImage: formik.values.frontImage,
                                    hasUploadedImage: !!formik.values.frontImage,
                                    setUploadedImage: data => formik.setFieldValue('frontImage', data),
                                    type: 'png, jpeg, jpg',
                                }} />
                                <HelperText {...{
                                    error: formik.touched.frontImage && Boolean(formik.errors.frontImage),
                                    helperText: formik.errors.frontImage,
                                }} />
                            </FormControl>
                        </Grid>
                    )
                }
                {
                    state.selectedCertificate && !values.certificateImage && state.selectedCertificate.isBackImageRequired === "True" && !eCardData && (
                        <Grid item className={classes.imageWrapper}>
                            <FormControl className={classes.formControl} error={formik.touched.backImage && Boolean(formik.errors.backImage)}>
                                <Typography variant="h6" gutterBottom className={classes.typography}>
                                    Back Image Upload
                                </Typography>
                                <DragNDrop {...{
                                    name: 'backImage',
                                    required: true,
                                    uploadedImage: formik.values.backImage,
                                    hasUploadedImage: !!formik.values.backImage,
                                    setUploadedImage: data => formik.setFieldValue('backImage', data),
                                    type: 'png, jpeg, jpg',
                                }} />
                                <HelperText {...{
                                    error: formik.touched.backImage && Boolean(formik.errors.backImage),
                                    helperText: formik.errors.backImage,
                                }} />
                            </FormControl>
                        </Grid>
                    )
                }
            </Fragment>
        );
    };


    return (
        <Fragment>
            <Grid item xs={12} md={5}>
                {isSmUp || hash.split('-').pop() === '1' ? renderCertificateFields() : null}
            </Grid>
            <Grid item xs={12} md={6}>
                {isSmUp || hash.split('-').pop() > '1' ? renderImageUploadFields() : null}
            </Grid>
            <DialogAlert {...{
                dialogProps: {
                    open: ecardAlert,
                },
                title: 'Is this an E-Card?',
                content: 'Using the E-Card function will auto-populate fields and images.',
                onYesClickHandler: () => handleEcardModal(),
                onNoClickHandler: () => setEcardAlert(false)
            }}
            />
        </Fragment>
    );
};

export default CertificateFields;